module.exports = __webpack_public_path__ + "static/media/7ICJ3.59cf3008.jpg";